"use client";

import type React from "react";
import { useCallback, useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Paper,
  IconButton,
  Tooltip,
  Stack,
  CircularProgress,
} from "@mui/material";
import { Info } from "@mui/icons-material";
import { useThoughtCoCreate } from "@/contexts/ThoughtCoCreateContext";
import { useNavigate, useParams } from "react-router";
import Deliverable1 from "./components/Deliverable1";
import Deliverable2 from "./components/Deliverable2";
import Deliverable3 from "./components/Deliverable3";
import Deliverable4 from "./components/Deliverable4";
import { apiRemote } from "@/api";

const deliverables: Record<string, React.FC> = {
  "1": Deliverable1,
  "2": Deliverable2,
  "3": Deliverable3,
  "4": Deliverable4,
};

export default function Deliverable() {
  const [statement, setStatement] = useState("");
  const wordCount = statement.trim().split(/\s+/).filter(Boolean).length;
  const { userCompetition, setUserCompetition, userRound, setUserRound, userRoundParts, setUserRoundParts, setAiUsage } = useThoughtCoCreate();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const DeliverableComponent = deliverables[id || "1"];

  const [loading, setLoading] = useState<boolean>(false);

  const loadUserRound = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiRemote.getUserRoundStatus();
      if (response?.competition) {
        setUserCompetition(response.competition);
      }
      if (response?.rounds) {
        setUserRound(response.rounds);
      }
      if (response?.round_parts) {
        setUserRoundParts(response.round_parts);
      }
      if (response?.ai_usage) {
        setAiUsage(response.ai_usage);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  }, []);


  useEffect(() => {
    if(!id){
      navigate(`..`);
    }
    if (userRound.length <= 0) {
      //   navigate(`..`);
      loadUserRound();
    }
  }, [id, userRound, userRoundParts, userCompetition]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle submission logic here
  };

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: "white",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        flex: 1,
        height: "100%",
      }}
    >
      {loading ? (
        <Box
          sx={{
            p: 3,
            bgcolor: "white",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            bgcolor: "background.default",
          }}
        >
          <Container maxWidth="lg">
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  mb: 1,
                }}
              >
                D{userRoundParts[Number(id) - 1]?.part_number}:{" "}
                {userRoundParts[Number(id) - 1]?.title}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                {userRoundParts[Number(id) - 1]?.description}
              </Typography>
            </Box>

            {DeliverableComponent ? <DeliverableComponent /> : ""}
          </Container>
        </Box>
      )}
    </Box>
  );
}
